export default function buildPostShopInquiry({
    apiEndpoint,
    apiTools
}) {
    return async function postShopInquiry(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/inquiry`
        })
       
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
            body: args.body
        });
        return await res.json();
    }
}